import { Box, ContentBlock, Inline, Stack } from 'braid-design-system';

import { CheckoutPageError } from 'src/app/shared/components/CheckoutPageError';
import { BackButton } from 'src/app/v2/components/BackButton';
import { HeaderSection } from 'src/app/v2/pages/PayAndPostV2/sections/header';

interface GenericErrorProps {
  onBackButtonClicked: () => void;
}

export const GenericError: React.FC<GenericErrorProps> = ({
  onBackButtonClicked,
}) => (
  <ContentBlock>
    <Box marginBottom="xxlarge" marginTop="large">
      <Stack space="xlarge">
        <HeaderSection />
        <CheckoutPageError />
        <Inline collapseBelow="tablet" space="xsmall">
          <BackButton onBackButtonClicked={onBackButtonClicked} />
        </Inline>
      </Stack>
    </Box>
  </ContentBlock>
);
